import React, { Component } from "react";
import "./App.css";
import Main from "./components/Main";

class LambdaDemo extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false, msg: null };
  }

  handleClick = (api) => (e) => {
    e.preventDefault();

    this.setState({ loading: true });
    fetch("/.netlify/functions/" + api)
      .then((response) => response.json())
      .then((json) => this.setState({ loading: false, msg: json.msg }));
  };

  render() {
    const { loading, msg } = this.state;

    return (
      <p>
        <button onClick={this.handleClick("hello")}>
          {loading ? "Loading..." : "Call Lambda"}
        </button>
        <button onClick={this.handleClick("async-dadjoke")}>
          {loading ? "Loading..." : "Call Async Lambda"}
        </button>
        <br />
        <span>{msg}</span>
      </p>
    );
  }
}

class App extends Component {
  componentDidMount() {
    window.process = {
      ...window.process,
    };
  }
  render() {
    return (
      <div className="App">
        {/* <NavBar /> */}
        <Main />
        {/* <header className="App-header"> */}
        {/* <img src={logo} className="App-logo" alt="logo" /> */}

        {/* <TokyoMap /> */}

        {/* link to another page, Tokyo Map */}

        <template>
          <LambdaDemo />
        </template>
        {/* <WinterFriends /> */}
        {/* </header> */}
      </div>
    );
  }
}

export default App;
